module.exports = __webpack_public_path__ + "img/person-solid.a50bea10.svg";